import React from "react";
import { MDXProvider } from "@mdx-js/react";
import { MDXRenderer } from "gatsby-plugin-mdx";
import { MDX_COMPONENTS } from "./mdx-components";

export function MdxRendererLocal({ children }) {
  return (
    <MDXProvider components={MDX_COMPONENTS}>
      <MDXRenderer>{children}</MDXRenderer>
    </MDXProvider>
  );
}
